export var Class_Colors;
(function (Class_Colors) {
    Class_Colors["COLOR_ORANGE"] = "orange";
    Class_Colors["COLOR_GREEN"] = "green";
    Class_Colors["COLOR_YELLOW"] = "yellow";
    Class_Colors["COLOR_BROWN"] = "brown";
    Class_Colors["COLOR_RED"] = "red";
    Class_Colors["COLOR_BLUE"] = "blue";
})(Class_Colors || (Class_Colors = {}));
export var Hex_Colors;
(function (Hex_Colors) {
    Hex_Colors["HEX_PRIM_ORANGE"] = "#E16A00";
    Hex_Colors["HEX_PRIM_GREEN"] = "#71951D";
    Hex_Colors["HEX_PRIM_YELLOW"] = "#FF9500";
    Hex_Colors["HEX_PRIM_BROWN"] = "#4E3200";
    Hex_Colors["HEX_PRIM_RED"] = "#AA1800";
    Hex_Colors["HEX_PRIM_BLUE"] = "#2C83A8";
})(Hex_Colors || (Hex_Colors = {}));
export var Darkness;
(function (Darkness) {
    Darkness["DARK"] = "dark";
    Darkness["DARKB"] = "darkb";
    Darkness["LIGHT"] = "light";
    Darkness["LIGHTEST"] = "lightest";
    Darkness["MEDIUM"] = "medium";
})(Darkness || (Darkness = {}));
